import { render, staticRenderFns } from "./div-foot.vue?vue&type=template&id=a93c5c32&scoped=true"
import script from "./div-foot.vue?vue&type=script&lang=js"
export * from "./div-foot.vue?vue&type=script&lang=js"
import style0 from "./div-foot.vue?vue&type=style&index=0&id=a93c5c32&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a93c5c32",
  null
  
)

export default component.exports